import { get } from 'es-toolkit/compat';
import { computed } from 'vue';

import { isListOfObjects } from '../../../types/utils';
import { normalizeText } from '../../utils/helpers';
import searchFuzzy from '../../utils/searchFuzzy';
import type { SearchMap, UseSearchArgs } from './useSearch.types';

export default function useSearch<Item = unknown>({ items, fieldNames, trackBy = 'id' }: UseSearchArgs<Item>) {
  const searchMap = computed<SearchMap>(() => {
    const newSearchMap = {};

    if (!fieldNames || !fieldNames.length) {
      return newSearchMap;
    }

    items.value.forEach((item) => {
      const itemKey = String(item[trackBy]);

      newSearchMap[itemKey] = fieldNames
        .map((fieldName) => {
          return normalizeText(get(item, fieldName.split('.'))); // get the field's value
        })
        .filter(Boolean)
        .join(' ');
    });

    return newSearchMap;
  });

  /**
   * Filter `items` by the `fieldNames`'s values.
   * @param options.fuzzy - will use fuzzy search if true
   */
  function searchFor(
    searchTerm: string,
    options?: {
      fuzzy?: boolean;
    },
  ): Item[] {
    if (options?.fuzzy && isListOfObjects(items.value)) {
      return searchFuzzy<Item>(searchTerm, items.value, { fieldNames });
    }

    return items.value.filter((item) => {
      const itemKey = String(item[trackBy]);

      return searchMap.value[itemKey].includes(searchTerm.trim().toLowerCase());
    });
  }

  return {
    searchFor,
  };
}

export * from './useSearch.types';
